import { Controller, useForm } from 'react-hook-form';
import { routes } from 'routes';
import { Button } from 'components/Button';
import { FormControl } from 'components/FormControl';
import { FormFooter } from 'components/FormFooter';
import { FormLine } from 'components/FormLine';
import { Input } from 'components/Input';
import { useMutation } from 'urql';
import { MUTATION_UPSERT_ARTIST } from 'queries/queries-booker';
import { useStore } from 'hooks/useStore';
import { useNavigate } from 'react-router-dom';
import { Toggle } from 'components/Toggle';
import { urlValidation } from 'screens/booking/forms/validations';

enum FORM_ARTIST {
	NAME = 'name',
	VAT = 'vat_invoicing',
	RIDER_LINK = 'rider_link',
}

export const ArtistForm = ({ defaultValues, id }) => {
	// nacist interprety, ktere pak priradime do selectu

	const { notifications } = useStore();

	const navigate = useNavigate();

	const localDefaultValues = {
		name: defaultValues?.name,
		vat_invoicing: defaultValues?.vat_invoicing,
		rider_link: defaultValues?.rider_link,
	};

	const {
		handleSubmit,
		register,
		control,
		watch,
		formState: { errors },
	} = useForm({ defaultValues: localDefaultValues });

	const [upsertRequest, executeUpsertRequest] = useMutation(MUTATION_UPSERT_ARTIST);

	const onSubmit = (data: any) => {
		// console.log('SUBMIT');
		// console.log(data);

		executeUpsertRequest({
			id: id ? id : null,
			input: { ...data },
		}).then((result) => {
			// console.log(result.data?.upsertArtist);

			if (result?.error) {
				// VYHODIT ERROR
				return false;
			} else {
				if (!id) {
					navigate(routes.booker.artist + result.data?.upsertArtist?.id + '/');
				} else {
					// THROW NOTIFIKATION SAVED
				}

				notifications.addNotification({ message: 'Interpret uložen.' });
			}

			// redirect to detail with link
		});
	};

	return (
		<form onSubmit={handleSubmit(onSubmit)}>
			{false && JSON.stringify(localDefaultValues)}
			<FormLine first>
				<FormControl
					required
					label="Jméno"
					htmlFor={FORM_ARTIST.NAME}
					labelWidth={160}
					error={errors[FORM_ARTIST.NAME]}
				>
					<Input
						width={240}
						placeholder=""
						{...register(FORM_ARTIST.NAME, {
							required: 'Zadejte jmeno interpret',
						})}
						error={!!errors[FORM_ARTIST.NAME]}
					/>
				</FormControl>
			</FormLine>

			<FormLine>
				<FormControl
					label="Rider"
					htmlFor={FORM_ARTIST.RIDER_LINK}
					labelWidth={160}
					error={errors[FORM_ARTIST.RIDER_LINK]}
				>
					<Input
						placeholder="https://"
						{...register(
							FORM_ARTIST.RIDER_LINK,
							urlValidation({
								url: 'Neplatný odkaz na web.',
							}),
						)}
						error={!!errors[FORM_ARTIST.RIDER_LINK]}
					/>
				</FormControl>
			</FormLine>

			<FormLine>
				<FormControl
					label="Plátce DPH"
					htmlFor={FORM_ARTIST.VAT}
					labelWidth={160}
					error={errors[FORM_ARTIST.VAT]}
					spaceMedium
				>
					<Controller
						name={FORM_ARTIST.VAT}
						control={control}
						defaultValue={false}
						render={({ field }) => {
							return <Toggle {...field} />;
						}}
					/>
				</FormControl>
			</FormLine>

			<FormFooter>
				<Button type="submit" isProcessing={upsertRequest.fetching}>
					{id ? 'Uložit' : 'Přidat'}
				</Button>
			</FormFooter>
		</form>
	);
};
